import React from "react";
import FormSignIn from "../components/FromSignIn/FormSignIn";

const Login = () => {
  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "24px 16px",
        background:
          "linear-gradient(135deg, #1e958c 0%, #0b4f6c 45%, #ffffff 100%)",
      }}
    >
      <FormSignIn />
    </div>
  );
};

export default Login;

